<div class="color-wrapper">
  <div class="color-wrapper-container">
    <div class="color-picker-component">
      <!-- Brand colors -->
      @if (brandSettingColor || brandColors?.length || accountColors?.length) {
        <div class="account-colors">
          <div class="account-colors-title">
            <span>
              {{ "widgets.color-picker.brand-colors" | translate }}
            </span>
            <mat-icon class="explainer" matTooltipClass="tooltip-item" matTooltip="{{ 'widgets.color-picker.brand-colors-explanation' | translate }}">
              info_outline
            </mat-icon>
          </div>
          <div class="brand-related-colors">
            <!-- Specific brand setting color -->
            @if (brandSettingColor) {
              <div class="brand-setting-color-and-label">
                <div
                  class="brand-setting-color"
                  matTooltipClass="tooltip-item"
                  [class.is-chosen]="colorInputValue === brandSettingColor && colorInputLabel === brandSettingColorLabel"
                  [style.backgroundColor]="brandSettingColor"
                  (click)="setNewBrandSettingColor(brandSettingColor, brandSettingColorLabel, TypeColor.BrandVarColor)"
                  matTooltip="{{ 'settings.customization.brand-settings.picker-tooltip' | translate }} ({{
                    formatBrandColorLabel(brandSettingColorLabel)
                  }})"></div>
                <p class="color-label specific">{{ formatBrandColorLabel(brandSettingColorLabel) }}</p>
              </div>
            }
            <!-- Other brand setting colors -->
            @for (brandColor of brandColors; track brandColor.label) {
              <div class="brand-color-and-label">
                <div
                  class="brand-color"
                  matTooltipClass="tooltip-item"
                  [class.is-chosen]="colorInputValue === brandColor.color && colorInputLabel === brandColor.label"
                  [style.backgroundColor]="brandColor.color"
                  (click)="setNewBrandSettingColor(brandColor.color, brandColor.label, TypeColor.BrandColor)"
                  matTooltip="{{ formatBrandColorLabel(brandColor.label) }} = {{ brandColor.color }}"></div>
                <p class="color-label">{{ formatBrandColorLabel(brandColor.label) }}</p>
              </div>
            }
            <!-- Account colors -->
            @for (accountColor of accountColors; track $index) {
              <div class="account-color-and-label" [attr.data-test]="'account-color-' + accountColor.key">
                <div
                  class="account-color"
                  matTooltipClass="tooltip-item"
                  data-test="account-color-swatch"
                  [class.is-chosen]="colorInputValue === accountColor.value && colorInputLabel === accountColor.key"
                  [style.backgroundColor]="accountColor.value"
                  matTooltip="{{ accountColor.key }} = {{ accountColor.value }}"
                  [style.backgroundColor]="accountColor.value"
                  (click)="setAccountColorAsChosen(accountColor, TypeColor.AccountColor)"></div>
                <p class="color-label">{{ accountColor.key | titlecase }}</p>
              </div>
            }
          </div>
          @if (showEditLink) {
            <a class="edit-brand-settings" href="/settings/customization" target="_blank">
              <span>{{ "widgets.color-picker.brand-colors-edit" | translate }}</span>
            </a>
          }
        </div>
      }

      <!-- Used colors -->
      @if (usedColors?.length) {
        <div class="account-colors">
          <div class="account-colors-title">
            <span>
              {{ "widgets.color-picker.used-colors" | translate }}
            </span>
            <mat-icon class="explainer" matTooltipClass="tooltip-item" matTooltip="{{ 'widgets.color-picker.used-colors-explanation' | translate }}">
              info_outline
            </mat-icon>
          </div>
          <div class="used-colors-list">
            <!-- Transparent -->
            <div
              class="used-colors-list-item checkered-background"
              matTooltipClass="tooltip-item"
              [class.is-chosen]="colorInputValue === transparentColor && (typeColor === TypeColor.UsedColor || !typeColor)"
              (click)="setColorFromPalette(transparentColor, TypeColor.UsedColor)"
              matTooltip="{{ 'widgets.color-picker.transparent' | translate }}"></div>
            <!-- Used colors -->
            @for (usedColor of usedColors; track $index) {
              @if (!usedColor.startsWith("linear-gradient") && !usedColor.startsWith("radial-gradient")) {
                <div class="used-colors-list-item-wrapper">
                  <div
                    class="used-colors-list-item"
                    matTooltipClass="tooltip-item"
                    matTooltip="{{ usedColor }}"
                    [class.is-chosen]="colorInputValue === usedColor && (typeColor === TypeColor.UsedColor || !typeColor)"
                    [style.background]="usedColor"
                    (click)="setColorFromPalette(usedColor, TypeColor.UsedColor)"></div>
                  <div class="delete-color-btn" (click)="deleteUsedColor(usedColor)">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="8"
                      height="8"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#fff"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round">
                      <line x1="18" y1="6" x2="6" y2="18" />
                      <line x1="6" y1="6" x2="18" y2="18" />
                    </svg>
                  </div>
                </div>
              }
              @if ((usedColor.startsWith("linear-gradient") || usedColor.startsWith("radial-gradient")) && !isSourceGradient && isGradientNeeded) {
                <div class="used-colors-list-item-wrapper">
                  <div
                    class="used-colors-list-item"
                    matTooltipClass="tooltip-item"
                    matTooltip="{{ usedColor }}"
                    [class.is-chosen]="colorInputValue === usedColor && (typeColor === TypeColor.UsedColor || !typeColor)"
                    [style.background]="usedColor"
                    (click)="setColorFromPalette(usedColor, TypeColor.UsedColor)"></div>
                  <div class="delete-color-btn" (click)="deleteUsedColor(usedColor)">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="8"
                      height="8"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#fff"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round">
                      <line x1="18" y1="6" x2="6" y2="18" />
                      <line x1="6" y1="6" x2="18" y2="18" />
                    </svg>
                  </div>
                </div>
              }
            }
          </div>
        </div>
      }

      <div class="custom-color-picker">
        <!-- Tab -->
        <mat-tab-group>
          <mat-tab>
            <ng-template mat-tab-label>
              <label class="tab-label" [style.font-size]="isGradientNeeded ? '12px' : '14px'">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M2 12C2 17.5228 6.47715 22 12 22C13.6569 22 15 20.6569 15 19V18.5C15 18.0356 15 17.8034 15.0257 17.6084C15.2029 16.2622 16.2622 15.2029 17.6084 15.0257C17.8034 15 18.0356 15 18.5 15H19C20.6569 15 22 13.6569 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path
                    d="M7 13C7.55228 13 8 12.5523 8 12C8 11.4477 7.55228 11 7 11C6.44772 11 6 11.4477 6 12C6 12.5523 6.44772 13 7 13Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path
                    d="M16 9C16.5523 9 17 8.55228 17 8C17 7.44772 16.5523 7 16 7C15.4477 7 15 7.44772 15 8C15 8.55228 15.4477 9 16 9Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path
                    d="M10 8C10.5523 8 11 7.55228 11 7C11 6.44772 10.5523 6 10 6C9.44772 6 9 6.44772 9 7C9 7.55228 9.44772 8 10 8Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
                {{ "widgets.color-picker.palettes" | translate }}
              </label>
            </ng-template>
            <div class="palettes">
              <div class="color-palette-wrapper">
                <div
                  class="color-palette-item white"
                  [style.backgroundColor]="white"
                  [title]="white"
                  [class.is-chosen]="colorInputValue === white && (typeColor === TypeColor.PaletteColor || !typeColor)"
                  (click)="setColorFromPalette(white, TypeColor.PaletteColor)"></div>
                @for (color of palettes; track $index) {
                  <div
                    class="color-palette-item"
                    [style.backgroundColor]="color"
                    [title]="color"
                    [class.is-chosen]="colorInputValue === color && (typeColor === TypeColor.PaletteColor || !typeColor)"
                    (click)="setColorFromPalette(color, TypeColor.PaletteColor)"></div>
                }
              </div>
            </div>
          </mat-tab>

          <mat-tab>
            <ng-template mat-tab-label>
              <label class="tab-label" [style.font-size]="isGradientNeeded ? '12px' : '14px'">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M12 20.4722C13.0615 21.4223 14.4633 22 16 22C19.3137 22 22 19.3137 22 16C22 13.2331 20.1271 10.9036 17.5798 10.2102M6.42018 10.2102C3.87293 10.9036 2 13.2331 2 16C2 19.3137 4.68629 22 8 22C11.3137 22 14 19.3137 14 16C14 15.2195 13.851 14.4738 13.5798 13.7898M18 8C18 11.3137 15.3137 14 12 14C8.68629 14 6 11.3137 6 8C6 4.68629 8.68629 2 12 2C15.3137 2 18 4.68629 18 8Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
                {{ "widgets.color-picker.picker" | translate }}
              </label>
            </ng-template>
            <div class="mix-color-container">
              <div class="color-area">
                <app-color-area [rgbColor]="rgbColor" (colorUpdated)="setNewColorFromArea($event)"></app-color-area>
              </div>
              <div class="color-sliders">
                <app-hue-slider [rgbColor]="rgbColor" (hueUpdated)="setNewHueFromSlider($event)" class="hue-slider"></app-hue-slider>
                <app-opacity-slider
                  [rgbColor]="rgbColor"
                  [opacity]="opacity"
                  (opacityUpdated)="setNewOpacityFromSlider($event)"
                  class="opacity-slider"></app-opacity-slider>
              </div>
              <span class="line-divide"></span>
              <div class="footer-wrapper-color-area">
                <div class="current-color" [style.backgroundColor]="colorInputValue"></div>
                <div class="color-input">
                  <mat-form-field class="color-field" appearance="outline">
                    <input
                      matInput
                      type="text"
                      [(ngModel)]="colorInputValue"
                      (change)="colorInputChanged()"
                      placeholder="{{ 'settings.customization.colors.color' | translate }}" />
                    @if (colorInputError) {
                      <mat-hint class="error">* {{ colorInputError }}</mat-hint>
                    }
                  </mat-form-field>
                </div>
                @if (sourceItem !== "account-color-edit-dialog") {
                  <div class="btn-add-color" [matTooltip]="'widgets.color-picker.add-your-colors' | translate" (click)="createNewAccountColor()">+</div>
                }
              </div>
              <!-- Gradient button -->
            </div>
          </mat-tab>

          <!-- Gradient tab -->
          @if (!isSourceGradient && isGradientNeeded) {
            <mat-tab>
              <ng-template mat-tab-label>
                <label class="tab-label" [style.font-size]="isGradientNeeded ? '12px' : '14px'">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" stroke-width="2" />
                    <defs>
                      <linearGradient id="gradTabIcon" x1="0" y1="0" x2="1" y2="1">
                        <stop offset="0%" stop-color="#516ce3" />
                        <stop offset="100%" stop-color="#4cb5ab" />
                      </linearGradient>
                    </defs>
                    <rect x="5" y="5" width="14" height="14" rx="1" fill="url(#gradTabIcon)" />
                  </svg>
                  {{ "widgets.color-picker.gradient.tab-label" | translate }}
                </label>
              </ng-template>
              <div class="gradient-tab-content">
                <app-gradient-color-tool
                  [currentGradient]="colorInputValue"
                  [sessionKey]="sessionKey"
                  [accountColors]="accountColors"
                  (gradientUpdated)="onGradientUpdated($event)"
                  (gradientApplied)="onGradientApplied($event)"
                  (closeGradientTool)="onGradientToolClosed()"></app-gradient-color-tool>
              </div>
            </mat-tab>
          }
        </mat-tab-group>
      </div>
    </div>
  </div>
</div>
<div class="close-btn" data-test="color-picker-close"><mat-icon class="iconClose" (click)="enterInput.emit()">close</mat-icon></div>
